import { render, staticRenderFns } from "./InterviewReview.vue?vue&type=template&id=6df2dada&scoped=true"
import script from "./InterviewReview.vue?vue&type=script&lang=js"
export * from "./InterviewReview.vue?vue&type=script&lang=js"
import style0 from "./InterviewReview.vue?vue&type=style&index=0&id=6df2dada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df2dada",
  null
  
)

export default component.exports